export default "\r\n  <canvas id=\"{{chart}}\" style=\"width: 100%;\">{{chart}}</canvas>\r\n";